(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.announcement-bar__item'));
      this.current = 0;
      this.speed = parseInt(this.dataset.speed, 10) || 4000;
      this.autoplay = this.dataset.autoplay !== 'false';
      this.paused = false;

      this.items.forEach((item, index) => {
        item.classList.toggle('is-active', index === 0);
      });

      if (this.items.length > 1 && this.autoplay) {
        this.start();
      }

      if (this.dataset.pauseOnHover === 'true') {
        this.addEventListener('mouseenter', () => {
          this.paused = true;
        });
        this.addEventListener('mouseleave', () => {
          this.paused = false;
        });
      }
    }

    start() {
      this.timer = setInterval(() => {
        if (this.paused) return;
        this.next();
      }, this.speed);
    }

    next() {
      if (this.items.length < 2) return;
      const prevIndex = this.current;
      this.current = (this.current + 1) % this.items.length;
      this.items[prevIndex].classList.remove('is-active');
      this.items[this.current].classList.add('is-active');
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
